/**
 * Custom javascript that will be attached to the minicart and handle when a link inside the minicart is clicked
 */
define([
    'jquery'
], function ($) {
    'use strict';

    //Add a click event to the minicart product list item, so that clicking anywhere within the <li> will take the user
    //to the item (unless they click the X of course)
    $('.minicart').on('click', '.product-item', function() {
        var $itemLi = $(this);
        window.location.href = $itemLi.data().url;
    });
});
